import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ParamMap } from '@angular/router';
import { combineLatest, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map, switchMap, tap } from 'rxjs/operators';
import { Activity } from '../models/activity.model';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  constructor(
    private http: HttpClient
  ) { }

  getActivityBySlug( activitySlug: string, providerId = 436 ): Observable<Activity> {

    const endpointUrl = `${environment.apiUrl}/providers/${providerId}/services?slug=${activitySlug}&expand=events,spots,location`;

    console.log( endpointUrl );   

     const responseToModel = ( response: any): any =>  {

      if ( response._embedded && response._embedded.service && response._embedded.service[0] ) {
          return new Activity( response._embedded.service[0] );
      } 

    } 
    
    return this.http.get(endpointUrl).pipe(
      map(response => responseToModel(response))
    );

  }


}